
import React, { useState } from 'react'
import PageBar from '../../dashboard/page-bar/PageBar'
import { FiSettings } from 'react-icons/fi';
import { AiOutlinePlus } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const ListCompanyMaster = () => {
    const [data, setData] = useState([])
    const handleDelete = () => {

    }
    return (
        <div className="pageWrapper">
            <PageBar title=" COMPANY MASTER LIST" />
            {/* <h3 className="page-title">
                COMPANY MASTER LIST
            </h3> */}
            <div className="pageTableWrapper">
                <div className="pageHeader">
                    <div className="pageTitle">
                        <FiSettings />
                        <h5>COMPANY MASTER LIST</h5>
                    </div>
                    <div className="addNew">
                        <Link to="/admin/add-company-master" className="btn btn-success">
                            <AiOutlinePlus /> Add New company
                        </Link>
                    </div>
                </div>

                <div className="pageBody">
                    <div className="pageTable">
                        <div className="tableLength">
                            {/* <div className="dataTables_length">
                                <select
                                  name="languageLevelDatatableAjax_length"
                                  className="form-select "
                                >
                                  <option value={10}>10</option>
                                  <option value={25}>25</option>
                                  <option value={50}>50</option>
                                  <option value={100}>100</option>
                                </select>{" "}
                                <span className="record">records</span>
                              </div> */}
                        </div>
                        <table inert className="table table-striped table-bordered ">
                            <thead>

                                <tr role="row" className="heading">
                                    <th>S.No</th>
                                    <th>Company Name </th>
                                    <th>Company Type</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data &&
                                    data?.map((item, i) => {
                                        return (
                                            <tr role="row" className="odd" key={i + 1}>
                                                <td>
                                                    {/* <span>{i + 1}</span> */}
                                                </td>
                                                <td>
                                                    {/* <span>{item?.company_id?.name}</span> */}
                                                </td>
                                                <td>
                                                    {/* <span>{item.jobTitle}</span> */}
                                                </td>
                                                {/* <td inert>{item.position?.position}</td> */}

                                                <td>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn btn-waram dropdown-toggle"
                                                            type="button"
                                                            id="dropdownMenuButton1"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            Action
                                                        </button>
                                                        <ul className="dropdown-menu">
                                                            <li>
                                                                <Link
                                                                    className="dropdown-item"
                                                                    to={`/admin/create-job/${item._id}`}
                                                                >
                                                                    Edit
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <a className="dropdown-item" href="#" onClick={() => { handleDelete(item._id) }}>
                                                                    Delete
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListCompanyMaster